import { Component } from "react";
import { connect } from "react-redux";
import { GET_ENTRY_PRICE, GET_MODEL_TOTAL_STATUS } from "../../redux/actions/constants";
import { realTimeTransactionsHeaderList } from "../../staticData/transactions";
import { connectionClass } from "../../websocket/socket";
import RealTimeTable from "./RealTimeTable";

class RealTimeStatus extends Component {
    componentDidMount() {
        //
        this.props.currenciesList?.map((currency) => {
            const {
                operations: { isBinanceOn, isModelOn, isTradeOn }
            } = currency;
            if (isModelOn) {
                connectionClass.socketInfo.off(`cndlsc-${currency.currencyId}`);

                connectionClass.socketInfo.on(
                    `cndlsc-${currency.currencyId}`,
                    ({ candleClosePrice, status }) => {
                        this.props.dispatchEntryPrice(
                            candleClosePrice,
                            currency.currencyId,
                            status
                        );
                    }
                );
                connectionClass.socketInfo.on(`orderstatus-${currency.currencyId}`, (data) => {
                    this.props.dispatchTotalStatus(currency.currencyId, data);
                });
            }
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.isModelOn && !prevProps.isModelOn) {
            this.props.currenciesList?.map((currency) => {
                const {
                    operations: { isBinanceOn, isModelOn, isTradeOn }
                } = currency;
                if (isModelOn) {
                    connectionClass.socketInfo.off(`cndlsc-${currency.currencyId}`);

                    connectionClass.socketInfo.on(
                        `cndlsc-${currency.currencyId}`,
                        ({ candleClosePrice, status }) => {
                            this.props.dispatchEntryPrice(
                                candleClosePrice,
                                currency.currencyId,
                                status
                            );
                        }
                    );
                    connectionClass.socketInfo.on(`orderstatus-${currency.currencyId}`, (data) => {
                        this.props.dispatchTotalStatus(currency.currencyId, data);
                    });
                }
            });
        }
        if (!this.props.isModelOn && prevProps.isModelOn) {
            connectionClass.socketInfo.off(`cndlsc-${this.props.currentCurrencyId}`);
            connectionClass.socketInfo.off(`orderstatus-${this.props.currentCurrencyId}`);
        }
    }

    render() {
        return (
            <div className="my-4 overflow-auto border-1">
                <RealTimeTable />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatchEntryPrice: (data, currentCurrencyId, currentSide) =>
            dispatch({
                type: GET_ENTRY_PRICE,
                payload: { currencyId: currentCurrencyId, side: currentSide, data }
            }),
        dispatchTotalStatus: (currencyId, data) =>
            dispatch({
                type: GET_MODEL_TOTAL_STATUS,
                payload: { currencyId, data }
            })
    };
};

const mapStateToProps = (state) => {
    const {
        persistedReducer: { currenciesList, isDarkMode, currentSide, currentCurrencyId }
    } = state;
    const {
        realTimeStatus,
        operations: { isBinanceOn, isModelOn }
    } = currenciesList[currentCurrencyId];
    const {} = currenciesList[currentCurrencyId][currentSide.side];
    return {
        currenciesList: Object.values(currenciesList),
        currentCurrencyId,
        isBinanceOn,
        currentSide,
        isModelOn,
        isDarkMode
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RealTimeStatus);
